import React, {useState} from "react";

import { useUser } from 'store/providers/app'

import PT from "assets/img/pt-mini.png";
import EN from "assets/img/en-mini.png";

import {FormTag} from "./form";
import {useQuery, useQueryClient} from "react-query";
import {i18n} from "translate/i18n";
import {toast} from "react-toastify";

import {delTag, getTags} from "services/Tags.service";

import Page from "components/Page";
import PaginationTable from "components/Pagination";
import {swalQuestion} from "components/Swal";

import {Select, SelectLang, setLabel} from './actions'
import {Tooltip} from "../../components/Tooltip";
import { useNavigate} from "react-router";

const Tags = () => {
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const {user, language} = useUser();

    const [tags, setTags] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginate, setPaginate] = useState([]);
    const [selected, setSelected] = useState('');
    const [lang, setLanguage] = useState(language);

    const {isFetching} = useQuery(['tags', currentPage, selected, lang],
        () => {
            return getTags(selected, true, currentPage, lang)
        }, {
            onSuccess: (res) => {

                setPaginate({
                    total: res.total,
                    from: res.from,
                    to: res.to
                })

                setTags(res.data)
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'))
            },
            retry: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true
        }
    )

    const handleDelete = (id) => {
        swalQuestion(`<b>${i18n.t('questions.deleteTag')}</b>`).then(r => {
            if (r.isConfirmed) {
                delTag(id)
                    .then(() => {
                        queryClient.invalidateQueries(["tags", currentPage, selected, lang])
                        queryClient.invalidateQueries(["listTags"])
                        toast.success(i18n.t('success.deletedTag'))
                    })
                    .catch(() => toast.error(i18n.t('error.badRequest')))
            }
        })
    }

    const handleEdit = (id) => {
        navigate(`/tags/edit/${id}`)
    }

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };

    const handleAdd = () => {
        navigate('/tags/add')
    }

    if (user.profile !== 1) {
        toast.error('Você não tem permissão para acessar esta área!');
        navigate('/')
    }

    return (
        <Page label="Tags" icon="bi bi-tags">

            <div className="row mt-4">

                <div className="col-12">
                    <div className="card border-0 shadow-sm p-0">
                        <div className="card-header">
                            <div className="row justify-content-end">
                                <div className="col-4 p-2">
                                    <Select setSelected={setSelected} />
                                </div>
                                <div className="col-4 p-2">
                                    {/*<SelectLang*/}
                                    {/*    setLanguage={setLanguage}*/}
                                    {/*    language={lang}*/}
                                    {/*/>*/}
                                </div>

                                <div className="col-4 p-2">
                                    <button className="btn btn-outline-success px-5 py-2 float-end bi-plus" onClick={() => handleAdd()}>Adicionar</button>
                                </div>

                            </div>
                        </div>
                        <div className="card-body table-responsive p-0">
                            <table className="table table-hover mb-0 align-middle">
                                <thead className="bg-primary text-uppercase text-sm">
                                <tr>
                                    <th className="py-4">Tag</th>
                                    <th className="py-4">{i18n.t('label.title')} PT</th>
                                    <th className="py-4">{i18n.t('label.title')} EN</th>
                                    <th className="py-4">{i18n.t('label.description')}</th>
                                    {/*<th className="py-4">{i18n.t('label.language')}</th>*/}
                                    <th/>
                                </tr>
                                </thead>

                                { !tags?.length &&
                                    <tbody>
                                    <tr>
                                        <td colSpan={5}>{i18n.t('upload.tableRecords')}</td>
                                    </tr>
                                    </tbody>
                                }

                                <tbody>
                                {tags.map((tag, index) => (
                                    <tr key={index} >
                                        <td>
                                            <p className="fw-bolder mb-0 text-sm">{setLabel(tag.tag_type_code)}</p>
                                        </td>
                                        <td>{tag.name}</td>
                                        <td>{tag.name_en}</td>
                                        <td>{tag.description ? tag.description : '-'}</td>
                                        {/*<td>{tag.language === 'pt-BR'*/}
                                        {/*    ? <img src={PT} width={25} alt="pt-BR"/>*/}
                                        {/*    : <img src={EN} width={25} alt="en-US"/>*/}
                                        {/*}*/}
                                        {/*</td>*/}
                                        <td className="d-flex gap-2">
                                            <Tooltip label={i18n.t('buttons.edit')}>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm bi-pencil"
                                                    onClick={() => handleEdit(tag.id)}
                                                />
                                            </Tooltip>
                                            <Tooltip label={i18n.t('buttons.delete')}>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm bi-trash"
                                                    onClick={() => handleDelete(tag.id)}
                                                />
                                            </Tooltip>
                                        </td>
                                    </tr>

                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="card-footer border-top-0 bg-white">
                            <PaginationTable
                                isFetching={isFetching}
                                paginate={paginate}
                                handlePageClick={handlePageClick}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </Page>
    )
}

export default Tags
